import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const ConfirmDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="confirm-dialog-title" BackdropProps={{style: { backgroundColor: 'transparent' }}}>
      <DialogTitle id="confirm-dialog-title">Zamknij chat</DialogTitle>
      <DialogContent>
        <DialogContentText>Czy na pewno chcesz zamknąć chat? Wszystkie wiadomości zostaną utracone.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Anuluj
        </Button>
        <Button onClick={onConfirm} color="secondary">
          Zamknij
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;